import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { FormattedMessage } from 'react-intl'
import SystemStatus from '../../app/systemStatus/systemStatus'

const SiteDetails = () => {
  return (
    <Stack direction="column" spacing={3} paddingTop={2}>
      <Typography variant="h4">
        <FormattedMessage id="page.site.status" />
      </Typography>
      <Typography>
        <FormattedMessage id="page.site.status.description" />
      </Typography>
      <SystemStatus />
    </Stack>
  )
}

export default SiteDetails
